export default __webpack_public_path__ + "static/ShowroomIcon-fbdced21358b90cd833c1a12d979c1ca.jpg";